var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { observe } from "mobx";
import { Observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Pagination } from "../..";
import { useTranslation } from "../../hooks/useTranslation";
import { SortableTable } from "../../SortableTable";
import { ColorOptions } from "../../types";
import { Article } from "../Article";
import { ArticleHeader } from "../ArticleHeader/ArticleHeader";
var INTERCEPT_RELOAD_MS = 250;
export var TABLE_LIMIT = 30;
export function ArticleTable(props) {
    if (props.table.form) {
        return React.createElement(Observer, null, function () { return React.createElement(ObservableArticleTable, __assign({}, props)); });
    }
    return React.createElement(ArticleTableContents, __assign({}, props));
}
function ObservableArticleTable(props) {
    var _a = props.table.form, values = _a.values, name = _a.name, type = _a.type;
    var _b = useState(type === "checkbox" && values[name] ? "".concat(values[name].length) : "0"), selected = _b[0], setSelected = _b[1];
    observe(values, function (changes) {
        return setSelected("".concat(changes.object[name].length) || "0");
    });
    return (React.createElement(ArticleTableContents, __assign({}, props, { selected: type === "checkbox" ? selected : undefined })));
}
function ArticleTableContents(_a) {
    var _b, _c, _d;
    var title = _a.title, subtitle = _a.subtitle, pageInfo = _a.pageInfo, extra = _a.extra, create = _a.create, children = _a.children, filters = _a.filters, loading = _a.loading, table = _a.table, pagination = _a.pagination, search = _a.search, selected = _a.selected, titleLevel = _a.titleLevel, tooltip = _a.tooltip;
    var t = useTranslation();
    var _e = useState(false), reload = _e[0], setReload = _e[1];
    useEffect(function () {
        if (reload) {
            setTimeout(function () { return setReload(false); }, INTERCEPT_RELOAD_MS);
        }
    }, [reload]);
    var handleSetOffset = function (offset) {
        setReload(true);
        pagination.setOffset(offset);
    };
    var handleOnSort = function (column, direction) {
        setReload(true);
        table.onSort && table.onSort(column, direction);
    };
    return (React.createElement(Article, null,
        React.createElement(ArticleHeader, { title: title || t("Results"), subtitle: subtitle, pageInfo: pageInfo, extra: extra, create: create, loading: loading || table.loading, filters: filters, search: search, hideResults: ((_b = table.form) === null || _b === void 0 ? void 0 : _b.type) === "checkbox", tooltip: tooltip, label: selected
                ? {
                    text: "".concat(selected, "/").concat((_c = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.totalRecords) !== null && _c !== void 0 ? _c : (((_d = table === null || table === void 0 ? void 0 : table.form) === null || _d === void 0 ? void 0 : _d.total) || "-"), " ").concat(t("selected")),
                    color: ColorOptions.Blue,
                }
                : undefined, titleLevel: titleLevel }, children),
        React.createElement(SortableTable, __assign({}, table, { headings: table.headings, data: table.data, onSort: handleOnSort, loading: loading || table.loading || reload })),
        pageInfo &&
            pageInfo.totalRecords > (pagination.limit || TABLE_LIMIT) && (React.createElement(Pagination, { offset: pagination.offset, totalRecords: pageInfo.totalRecords, limit: pagination.limit || TABLE_LIMIT, setOffset: handleSetOffset, maxPagesDisplayed: 7 }))));
}
